import React, { useState, useEffect } from 'react'
import { useForm } from "react-hook-form";

// components
import IndustrySelector from './IndustrySelector'
import Costing from './Costing'
import JobCreation from './JobCreation'
import styled, { keyframes } from 'styled-components'
import Loader from '../Loader'
import { BtnGray as CBtnGray } from '../StyledComponents'

// styled components
const fadeIn = keyframes`
  0% {
    opacity: 0;
    transform: translateX(5%);
  }
  50% {
    transform: translateX(0%);
  }
  100% {
    opacity: 1;
  }
`

const FadeIn = styled.div`
  animation: 0.5s ${fadeIn} ease-out;
`

const BtnGray = styled(CBtnGray)`
  position: absolute;
  top: 2px;
  right: 2px;
  border-radius: 2px;
`

// function and properties
let defaultValues = {
  hardCost: '',
  duration: 1,
  furniture: '',
  architecture: '',
  revenue: ''
}

const Calculator = ({ isOpened, address, tractData }) => {

  const [step, setStep] = useState(1);
  const [industry, setIndustry] = useState(null);
  const [status, setStatus] = useState(null);
  const [details, setDetails] = useState(null);

  const form = useForm({defaultValues});

  useEffect(() => {
    if(isOpened === false)
      setStep(1);
  }, [isOpened])

  useEffect(() => {
    setStep(1);
    setStatus(null)
  }, [address])

  useEffect(() => {
    window.scrollTo(0, 0);
    if(step === 2)
      form.reset({...defaultValues})
  }, [step])

  function onIndustrySelect( data ) {
    setIndustry(data);
    setStep(2);
  }
  
  function onCalculation( details ) {
    Object.assign(defaultValues, form.getValues());
    setDetails(details);
    setStatus(details.jobs >= 10 ? 'success' : 'error');
    setStep(3);
  }

  if(isOpened === false)
    return <></>

  return (
    <div>

      {
        isOpened &&
        <Loader isLoading={tractData === null} />
      }

      {/* STEP 1 - INDUSTRY SELECTION */}
      {
        step == 1 &&
        <FadeIn>
          <IndustrySelector onSelect={onIndustrySelect} tractData={tractData} />
        </FadeIn>
      }

      {/* STEP 2 - COSTING */}
      {
        step == 2 &&
        <>
          <div align="right">
            <BtnGray small="true" onClick={() => setStep(1)}>Back</BtnGray>
          </div>
          <FadeIn>
            <Costing
              onCalculation={onCalculation}
              tractData={tractData}
              industry={industry}
              address={address.formatted_address}
              form={form}
            />
          </FadeIn>
        </>
      }

      {/* STEP 3 - JOB CREATION */}
      {
        step == 3 && status !== null &&
        <>
          <div align="right">
            <BtnGray small="true" onClick={() => setStep(2)}>Back</BtnGray>
          </div>
          <FadeIn>
            <JobCreation
              status={status}
              userInput={{
                address: address.formatted_address,
                industry: industry.name,
                ...details
              }}
            />
          </FadeIn>
        </>
      }

    </div>
  )
}

export default Calculator;
